import React from 'react';

/**
 * The "next step" mark: two forward chevrons that step up and forward — the
 * motion of moving a deal to its next step. Used standalone and in the wordmark.
 */
export function Mark({ size = 32, className = '' }) {
  const id = React.useId();
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      role="img"
      aria-label="Next Step Followup"
      className={className}
    >
      <defs>
        <linearGradient id={`${id}-bg`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="hsl(var(--primary))" />
          <stop offset="1" stopColor="hsl(var(--ink))" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="15" fill={`url(#${id}-bg)`} />
      <path
        d="M15 40 L27 28 L15 16"
        fill="none"
        stroke="hsl(var(--primary-foreground))"
        strokeOpacity="0.55"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30 48 L46 32 L30 16"
        fill="none"
        stroke="hsl(var(--accent))"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Logo({ className = '', markSize = 32 }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <Mark size={markSize} />
      <span className="font-display text-lg font-bold leading-none tracking-tight">
        <span className="text-foreground">Next Step</span>{' '}
        <span className="text-primary dark:text-accent">Followup</span>
      </span>
    </span>
  );
}

export default Logo;
